// Route helpers shared by the Us screens (U1, U3, U4). The route comes from the server (state.buddy.route, absolute
// levels); stops past ROUTE_READY have no content in this build and show "Coming soon" (SPEC §8, option A).
import type { BuddyState, LevelInfo, RouteStop, StopType } from '@shared/types';
import { COMING_SOON_LABEL } from '@shared/rules';
import type { IconName } from '../../components';

export const STOP_ICON: Record<StopType, IconName> = { keep: 'gift', chap: 'book', place: 'home', sound: 'music', season: 'star' };

/** The next stop to reach (the first one not reached), or null when the whole route is open. */
export const nextStop = (b: BuddyState): RouteStop | null => b.route.find((r) => !r.reached) || null;

/** QU1 stopName: chapter / place / sound labels as the server gives them, keepsakes prefixed; no content yet: "Coming soon". */
export const stopName = (r: RouteStop) => (!r.ready ? COMING_SOON_LABEL : r.type === 'keep' ? `Keepsake: ${r.label}` : r.label);

/** Under a locked stop: "Level N", or "Coming soon" past the month-one build. */
export const lockedLabel = (r: RouteStop) => (r.ready ? `Level ${r.level}` : COMING_SOON_LABEL);

/** SPEC §8: "About K cards away", K = ceil(points left / 15). */
export const cardsAway = (lv: LevelInfo) => Math.max(1, Math.ceil((lv.need - lv.into) / 15));

export const plural = (n: number, one: string, many = one + 's') => `${n} ${n === 1 ? one : many}`;

/** The keepsake stops in route order (8 in season 1). */
export const keepStops = (b: BuddyState) => b.route.filter((r) => r.type === 'keep');
